export default {
  first: 'Home',
  second: 'About',
  login: 'Login',
};
